import unsubscribe from "../../assets/images/unsubscribe-mail.jpg";
import PageTitle from "../../components/common/PageTitle";
import React, { useEffect, useState } from 'react'
import { injectIntl } from "react-intl"
import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { changeLocale } from "../../redux/actions/Common";
import { getLocale } from "../../utils/compute";
import { unsubscribeNotification } from "../../redux/api/Talent";

const Unsubscribe = ({ intl }) => {
  const dispatch = useDispatch()
  let lang = new URLSearchParams(window.location.search)?.get('lang') || 'en';
  useEffect(() => {
    dispatch(changeLocale(getLocale(lang)))
  }, [])
  let token = new URLSearchParams(window.location.search)?.get('token') || '';
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const handleUnsubscribe = async () => {
    setIsLoading(true);
    setError(false);
    setSuccess(false);
    try {
      const response = await unsubscribeNotification(token);
      if (response.status === 200) {
        setSuccess(true);
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    }
    setIsLoading(false);
  };
  return (
    <div className=" h-screen w-full flex justify-center items-center">
      <div className="flex flex-col xl:flex-row  justify-center gap-10  w-[50%]">
        <div className="shadow-xxl rounded-4xl">
          <img
            src={unsubscribe}
            className="shadow-xxl rounded-4xl h-full xl:w-full object-cover"
          />
        </div>
        <div className=" flex flex-col items-center justify-center gap-5 shadow-xxl rounded-4xl px-8 py-7">
          <PageTitle title={"unsubscribe"} />
          <p className="text-xl text-center ">
            {intl.formatMessage({ id: 'If you unsubscribe, we will not be able to send you notifications.' })}
          </p>
          <p className=" text-secondary text-xl ">
            {intl.formatMessage({ id: 'Do you want to unsubscribe?' })}
          </p>
          <div className="flex gap-10">
            <Link to={'/'}
              className="px-8 py-2 text-secondary border-2 border-secondary rounded-full flex items-center justify-center">{intl.formatMessage({ id: 'cancel' })}
            </Link>
            <button className="bg-secondary rounded-full text-white px-8"
              type="submit"
              disabled={isLoading | success}
              onClick={handleUnsubscribe}
            >
              {isLoading ? (
                <>
                  <svg aria-hidden="true" role="status" className="inline w-4 h-4 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                  </svg>
                  {intl.formatMessage({ id: 'unsubscribe' })}...
                </>
              ) : (
                intl.formatMessage({ id: 'unsubscribe' })
              )}

            </button>

          </div>
          {error && (
            <div className="flex items-center p-4 text-sm text-red-800 rounded-lg bg-red-50" role="alert">
              <svg className="flex-shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
              </svg>
              <div>{intl.formatMessage({ id: 'error.generic' })}</div>
            </div>
          )}
          {success && (
            <div className="flex items-center p-4 text-sm text-green-800 rounded-lg bg-green-50" role="alert">
              <div>{intl.formatMessage({ id: 'success.unsubscribe' })}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default injectIntl(Unsubscribe);
